import {ShopPageTitle} from "../shop/_components/ShopPageTitle";
import React, {useEffect} from "react";
import {useBasket} from "../shop/useShop";
import {useAddressDetails} from "../backend2/address/useAddress";
import {useCarrierDetails} from "../backend2/admin/carrier/useCarrier";
import {Button, Spinner, Table} from "react-bootstrap";
import {Link, Navigate, useNavigate} from "react-router-dom";
import {useAlert, useAuth} from "../../context";
import {Formik, Form as FormikForm} from "formik";
import {OurClearAlert} from "../_components";
import {usePaymentDetails} from "../shop/usePayment";
import {PaypalWrapper} from "./Paypal";
import {PaymentMethods} from "../../utils2/maps";
import {centsToUnits} from "../backend2/admin/utilities/formatCurrency";

export function ReviewOrder() {
    const {success} = useAlert()
    const {userId, bskToken} = useAuth()
    const navigate = useNavigate()
    const {basket, submitOrder, errorArticle, loadingArticle, clearErrorArticle} = useBasket()

    const {
        value: shippingAddress,
        errorValue: shippingAddressError,
        clearError: shippingAddressClearError
    } = useAddressDetails(basket?.address_id, userId, null)

    const {
        value: billingAddress,
        errorValue: billingAddressError,
        clearError: billingAddressClearError
    } = useAddressDetails(basket?.billing_id, userId, null)

    const {
        value: paymentMethod,
        error: paymentMethodError,
        clearError: paymentMethodClearError
    } = usePaymentDetails(basket?.payment_id, null)


    const goBack = "/checkout/payment"

    function handleSubmit(values, actions) {
        // Submit order procedure for Bank
        submitOrder()
            .then(data => {
                success(`Thank you for your order #${data.order_number}! Now, you can finalize the payment.`)
                navigate(`/backend/order/${userId}/${data.id}`)
            })
            .catch(console.warn)
            .finally(() => actions.setSubmitting(false))
    }

    function handlePayPalOnSuccess(transactionId) {
        // Submit order procedure for PayPal
        submitOrder(transactionId)
            .then(data => {
                success(`Thank you for your order #${data.order_number}! Your payment via PayPal has been received.`)
                navigate(`/backend/order/${userId}/${data.id}`)
            })
            .catch(console.warn)
    }

    // if (!bskToken || (loadingArticle === false && basket?.articles.length === 0)) {
    //     return <Navigate to="/shop"/>
    // }
    useEffect(() => {
        // This is useEffect is needed because <Navigate> always overwrites navigate in handleSubmit
        const jsonValue = window.localStorage.getItem("bsk_token")
        if (jsonValue == null || jsonValue === "null")
            navigate("/shop")
    }, [])

    if (basket && basket?.address_id == null) {
        return <Navigate to="/checkout/address"/>
    }

    if (basket && basket?.carrier_id == null) {
        return <Navigate to="/checkout/delivery"/>
    }

    if (basket && basket?.payment_id == null) {
        return <Navigate to="/checkout/payment"/>
    }

    return <>

        <OurClearAlert variant="danger" msg={errorArticle} onClear={clearErrorArticle}/>
        <OurClearAlert variant="danger" msg={shippingAddressError} onClear={shippingAddressClearError}/>
        <OurClearAlert variant="danger" msg={billingAddressError} onClear={billingAddressClearError}/>
        <OurClearAlert variant="danger" msg={paymentMethodError} onClear={paymentMethodClearError}/>

        <ShopPageTitle title="Review Orders & Pay"/>

        <Formik initialValues={basket} onSubmit={handleSubmit} enableReinitialize={true}>
            {({isSubmitting}) => (
                <FormikForm>

                    <Summary basket={basket} selectedPayment={paymentMethod} shippingAddress={shippingAddress} billingAddress={billingAddress}/>

                    <div className="d-flex justify-content-end mt-4">
                        <Button as={Link} variant="link" to={goBack}>Go back</Button>

                        {paymentMethod == null ?
                            <Spinner animation="border"/>
                            :
                            <>
                                {paymentMethod?.description.toLowerCase() === PaymentMethods.Bank &&
                                    <Button variant="success" type="submit" disabled={isSubmitting}>Bank details & Pay</Button>
                                }
                                {paymentMethod?.description.toLowerCase() === PaymentMethods.PayPal &&
                                    <div className="w-50"><PaypalWrapper basket={basket} country={billingAddress?.country} onSuccess={handlePayPalOnSuccess}/></div>
                                }
                            </>
                        }
                    </div>

                </FormikForm>
            )}
        </Formik>

    </>
}

function Summary({basket, selectedPayment, shippingAddress, billingAddress}) {
    const {value: selectedCarrier, loadingValue: carrierLoading, errorValue: carrierError, clearError: carrierClearError} = useCarrierDetails(basket?.carrier_id)

    return <>
        <OurClearAlert variant="danger" msg={carrierError} onClear={carrierClearError}/>

        <div className="d-flex flex-wrap justify-content-between my-2">
            <RenderAddress title="Shipping address" address={shippingAddress}/>
            <RenderAddress title="Billing address" address={billingAddress}/>
        </div>

        <div className="my-2">
            <Table className="">
                <thead className="">
                <tr>
                    <th>Article</th>
                    <th className="text-end">Qty.</th>
                    <th className="text-end">Price (excl. VAT)</th>
                    <th className="text-end">Subtotal</th>
                </tr>
                </thead>
                <tbody className="table-group-divider">
                {basket ?
                    basket.articles.map((item, index) =>
                        <tr key={index}>
                            <td>{item.title}</td>
                            <td className="text-end">{item.quantity}</td>
                            <td className="text-end">€ {item.unit_price}</td>
                            <td className="text-end">€ {(item.total_price)}</td>
                        </tr>)
                    :
                    <tr>
                        <td>Loading...</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>}

                <tr>
                    <td colSpan={2} className="">Shipping costs</td>
                    {(!selectedCarrier || carrierLoading) ?
                        <td className="text-end">Loading...</td>
                        :
                        <>
                        <td className="text-end">€ {selectedCarrier.price}</td>
                        <td className="text-end">€ {selectedCarrier.price}</td>
                        </>
                    }
                </tr>
                {basket?.vat_percentage > 0 && <tr>
                    <td colSpan={3} className="">VAT {basket?.vat_percentage}%</td>
                    <td className="text-end">€ {centsToUnits(basket?.total_vat)}</td>
                </tr>}

                </tbody>
                <tfoot className="table-group-divider">
                <tr className="fw-bolder">
                    <td colSpan={3} className="text-end">Total</td>
                    <td className="text-end">€ {centsToUnits(basket?.total_gross)}</td>
                </tr>
                </tfoot>
            </Table>
        </div>

        <div className="d-flex gap-2">
            <div className="fw-bolder">Payment method:</div>
            <div className="text-capitalize">{selectedPayment ? selectedPayment?.description : "Loading..."}</div>
        </div>
        {selectedPayment?.description === PaymentMethods.PayPal && <div>* A 1% processing fee applies to payments made via PayPal.</div>}
    </>
}

function RenderAddress({title, address}) {
    return <div>
        <div className="fw-bolder">{title}:</div>
        <div className="">
            {address ?
                <>
                    <div>{`${address.name}, ${address.line1}`}</div>
                    <div>{`${address.city} ${address.zip}, ${address.country}`}</div>
                    <div>{`+${address.prefix}${address.phone}`}</div>
                </>
                :
                <>
                    <div>Loading...</div>
                </>
            }
        </div>
    </div>
}
